<template>
	<div>
		<a-modal v-model="currencyvisit" :title="audit ? '需求反馈重新提交' : '需求反馈'" @ok="currencyOk" width="90%">
			<template slot="footer">
				<a-button key="submit" type="primary" @click="currencyOk"> 提交 </a-button>
				<a-button key="back" @click="currencyvisit = false"> 取消 </a-button>
			</template>
			<a-form-model :model="currencyform" ref="tyruleForm" :rules="rules" :label-col="labelCol3" :wrapper-col="wrapperCol3">
				<a-row><span class="form_title2">表单信息</span></a-row>
				<a-row>
					<a-form-model-item label="选择抄送人" :label-col="labelCol2" :wrapper-col="wrapperCol2">
						<ccChange :data="ccC" @targetKeys="currencygetdata" v-if="isRouterAlive" />
					</a-form-model-item>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="需求对接人" prop="demandContact" :rules="{
						  required: true,
						  message: '请输入需求对接人',
						  trigger: 'change',
						}">
						<a-input allowClear v-model="currencyform.demandContact" placeholder="需求对接人" />
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="联系方式" prop="contactTel" :rules="[{
						  required: true,
						  message: '请输入联系方式',
						  trigger: 'change',
						},
						{
						  required: true,
						  message: '请输入正确的手机号码',
						  pattern: new RegExp(/^((13[0-9])|(14[0-9])|(15[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/),
						  trigger: 'change',
						}]">
						<a-input allowClear v-model="currencyform.contactTel" placeholder="对接人联系方式" />
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="所属系统" prop="affiliatedSystem" :rules="{
						  required: true,
						  message: '请选择所属系统',
						  trigger: 'change',
						}">
						<a-select allowClear v-model="currencyform.affiliatedSystem" placeholder="请选择" @change="getid">
							<a-select-option :key="index" v-for="(item, index) in affiliated" :value="item.value">
								{{ item.label }}
							</a-select-option>
						</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="需求处理人">
							<span>{{processing}}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="实施原因" prop="implementationReasons" :label-col="labelCol2" :wrapper-col="wrapperCol2" :rules="{
						  required: true,
						  message: '请输入实施原因',
						  trigger: 'change',
						}">
							<a-textarea :auto-size="{ minRows: 5, maxRows: 10 }" v-model="currencyform.implementationReasons" placeholder="请描述在什么场景下的什么行为遇到了什么问题，例如: 在采购物品的过程中需要退货，无退货流程。"></a-textarea>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="实施内容" prop="content" :label-col="labelCol2" :wrapper-col="wrapperCol2" :rules="{
						  required: true,
						  message: '请输入实施内容',
						  trigger: 'change',
						}">
							<a-textarea :auto-size="{ minRows: 5, maxRows: 10 }" v-model="currencyform.content" placeholder="请描述实施的内容，例如：希望增加退货出库流程。"></a-textarea>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
						<a-form-model-item label="实施后预计效果" prop="expectedEffect" :label-col="labelCol2" :wrapper-col="wrapperCol2" :rules="{
						  required: true,
						  message: '请输入实施后预计效果',
						  trigger: 'change',
						}">
							<a-textarea :auto-size="{ minRows: 5, maxRows: 10 }" v-model="currencyform.expectedEffect" placeholder="请描述实施后预计效果，例如：希望可以通过系统对不合格的产品进行退货出库。"></a-textarea>
						</a-form-model-item>
					</a-col>
				</a-row>
				<!-- <a-row>
					<a-col :span="24">
						<a-form-model-item label="审批详情" prop="detail" :label-col="labelCol2" :wrapper-col="wrapperCol2" :rules="{
						  required: true,
						  message: '请输入审批详情',
						  trigger: 'change',
						}">
							<a-textarea :auto-size="{ minRows: 5, maxRows: 10 }" v-model="currencyform.detail" placeholder="请输入"></a-textarea>
						</a-form-model-item>
					</a-col>
				</a-row> -->
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="图片" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
							<uploadImgJava :data="uploadDataImg" v-if="isRouterAlive" />
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="附件" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
							<uploadFileCode :data="uploadData" v-if="isRouterAlive" />
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>
		</a-modal>
	</div>
</template>

<script>
	import {
		feedback_code,
		feedback_save,
	} from '@/api/financial'
	import ccChange from '@/components/module/ccChange'
	import uploadFileCode from '@/components/module/uploadFileCode.vue'
	import uploadImgJava from '@/components/module/uploadImgJava.vue'
	export default {
		components: {
			ccChange,
			uploadImgJava,
			uploadFileCode
		},
		data() {
			return {
				currencyvisit: false,
				currencyform: {
					cc: [],
					applyCode: '',
					content: '',
					detail: '',
					expectedEffect:'',
					implementationReasons:'',
					contactTel:'',
					demandContact:'',
				},
				uploadDataImg: {
					code: '',
					type: 'feedback-certificate',
				},
				uploadData: {
					code: '',
					type: 'feedback-appendix',
				},
				labelCol2: {
					span: 3
				},
				wrapperCol2: {
					span: 21
				},
				labelCol3: {
					span: 9
				},
				wrapperCol3: {
					span: 15
				},
				isRouterAlive: false,
				audit: false,
				ccC:'feedback',
				processing:'',
			}
		},
		props: {
			data: {
				type: Object,
				default: true,
			},
		},
		watch: {
			data(val, old) {
				console.log(val, old)
			},
		},
		created() {},
		methods: {
			getid($event){
				if($event!==''){
					this.processing=this.affiliated[$event-1].name
				}else{
					this.processing=''
				}
			},
			show(res) {
				if (res) {
					this.audit = true
					this.currencyform = res
					this.processing=this.affiliated[res.affiliatedSystem-1].name
				} else {
					this.currencyform = {
						cc: [],
						applyCode: '',
						content: '',
						detail: '',
						expectedEffect:'',
						implementationReasons:'',
						contactTel:'',
						demandContact:'',
					}
				}
				this.currencyvisit = true
				this.isRouterAlive = false
				this.$nextTick(() => {
					this.isRouterAlive = true
				})
				feedback_code().then(res => {
					this.currencyform.applyCode = res.data
					this.uploadDataImg.code = res.data
					this.uploadData.code = res.data
				})
			},
			currencygetdata(data) {
				this.currencyform.cc = data
			},
			currencyOk() {
				this.$refs.tyruleForm.validate((valid) => {
					if (valid) {
						this.currencyform.cc = this.currencyform.cc.length ? this.currencyform.cc.join(',') : ''
						feedback_save(this.currencyform).then(res => {
							if (res.code == 200) {
								this.currencyvisit = false
								this.$message.success('保存成功')
								this.$emit('ok')
							} else {
								this.$message.error(res.msg)
							}
						})
					}
				})
			},
		},
	}
</script>
